import RoleType from '../routes/RoleGroup/Roles/RoleType';
import {routeUrl} from '../routes/routeUrl';

export function checkRole (requiredRoles, router) {
  let roles = JSON.parse(localStorage.getItem('roles'));

  let hasRole = false;
  requiredRoles.forEach(requiredRoleType => {
    roles.forEach(role => {
      if (role.roleType && RoleType.enumValueOf(role.roleType.name) === requiredRoleType) {
        hasRole = true;
      }
    });
  });

  if (!hasRole) {
    router.push(routeUrl.unAuth);
  }
}



// WEBPACK FOOTER //
// ./src/util/RoleChecker.js